import TextSelectionMenu from "components/TextSelectionMenu/TextSelectionMenu";
import TranslationTool from "./TranslationTool";
import "../tabs.css";

type TranslateTabProps = {
  searchText: string;
  isSelectionOpened: boolean;
};

export default function TranslateTab({
  searchText,
  isSelectionOpened,
}: TranslateTabProps) {
  return (
    <div className="translate-items" id="translate-items">
      <TranslationTool searchText={searchText} />
      <TextSelectionMenu
        isContextMenuOpened={isSelectionOpened}
        scrollableParentId="translate-items"
        positionalParentId="sidebar-id"
        selectionContext="sidebar"
      />
    </div>
  );
}
